import type { Translation } from '../../../translations'
import type { Message } from '../types'
import { ChatMessage } from './ChatMessage'

interface ChatMessageListProps {
    messages: Message[]
    t: Translation
    onCopyAnswer: (text: string) => void
    onDownloadAnswer: (filename: string, content: string) => void
    onCopyLink: (url: string) => void
    expandedSources: Record<string, boolean>
    onToggleSource: (key: string) => void
    onRelatedQuestionClick: (question: string) => void
}

export function ChatMessageList({
    messages,
    t,
    onCopyAnswer,
    onDownloadAnswer,
    onCopyLink,
    expandedSources,
    onToggleSource,
    onRelatedQuestionClick
}: ChatMessageListProps) {
    return (
        <>
            {messages.map((message, index) => (
                <ChatMessage
                    key={index}
                    message={message}
                    isOwn={message.role === 'user'}
                    t={t}
                    onCopyAnswer={onCopyAnswer}
                    onDownloadAnswer={onDownloadAnswer}
                    onCopyLink={onCopyLink}
                    expandedSources={expandedSources}
                    onToggleSource={onToggleSource}
                    onRelatedQuestionClick={onRelatedQuestionClick}
                />
            ))}
        </>
    )
}
